import React, {PureComponent, ReactNode} from 'react';
import CurrentDeposit from './CurrentDeposit';
import SystemCard from 'app/components/deposit/SystemCard';
import PaymentSystemInterface from 'app/interfaces/PaymentSystemInterface';
import HelpSupport from 'app/components/deposit/form/HelpSupport';
import P2pDepositSteps from 'app/components/deposit/p2p/P2pDepositSteps';
import CurrentP2pDepositInterface from 'app/interfaces/CurrentP2pDepositInterface';
import {isDesktop} from 'app/utils';
import {translatedKeyLangs} from 'app/utils/translations_helper';

interface CurrentP2pDepositProps {
    current_p2p_deposit: CurrentP2pDepositInterface
    firstDeposit: boolean
    system: PaymentSystemInterface
}

export default class CurrentP2pDeposit extends PureComponent<CurrentP2pDepositProps> {
    render(): ReactNode {
        const {system, current_p2p_deposit: {working, waiting, user_verified_documents}} = this.props;
        return <div className="current-p2p-deposit">
            <div className="card-transfer">
                <div className="face">
                    <div className={'deposit-form__logo payment-systems__deposit__item ' +
                        'payment-systems__deposit__item__selectedSystem'}
                    >
                        <SystemCard system={system}/>
                    </div>
                    {isDesktop() && <div className="description">
                        <p dangerouslySetInnerHTML={{__html: translatedKeyLangs(system, 'deposit_description')}}/>
                    </div>}
                </div>
                <div className="body">
                    <CurrentDeposit system={system} />
                </div>
            </div>
            {(waiting || working) &&
            <P2pDepositSteps waiting={waiting} user_verified_documents={user_verified_documents}/>}
            {!isDesktop() && <div className="box-p2p_type-1"><HelpSupport/></div>}
        </div>;
    }
}
